import './notes.scss';

import { Alert, AlertTitle, Grid } from '@mui/material';
import {
  CreateNoteTargetInput,
  NoteTargetAreaType,
  NotesListData,
  getPaginatedNodes,
  useGetNotes,
} from '@converge/graphql';

import { NoteCreateForm } from './note.create.form';
import { NoteList } from './note.list';
import { NotesHeader } from './notes.header';
import Warning from '@mui/icons-material/Warning';

export interface INotesProps extends CreateNoteTargetInput {
  data?: NotesListData;
  title: string;
  hideHeader?: boolean;
  containerWidth?: number;
  testId?: string;
  targetArea?: NoteTargetAreaType;
  targetSubUuid?: string | null | undefined;
  targetSubName?: string | null | undefined;
  label?: string[] | null | undefined;
  onClose?: () => void;
  showBtn?: boolean | undefined;
  callHandleUpdateRenewalType?: () => void;
  disabled?: boolean;
  LabelForConfirmBtn?: string;
  showMessage?: boolean;
}

export const ConvergeNotes = ({
  title,
  data,
  hideHeader,
  targetName,
  targetType,
  targetUuid,
  containerWidth,
  testId,
  targetArea,
  targetSubUuid,
  targetSubName,
  label,
  showBtn,
  onClose,
  LabelForConfirmBtn,
  callHandleUpdateRenewalType,
  disabled,
  showMessage = true,
}: INotesProps) => {
  const { notes } = useGetNotes({
    targetUuid,
    targetType,
    targetName,
    targetArea,
    targetSubUuid,
    targetSubName,
    label,
  });
  return (
    <Grid item xs={12} md={containerWidth} data-testid={testId}>
      {!hideHeader && <NotesHeader title={title} />}

      <NoteCreateForm
        LabelForConfirmBtn={LabelForConfirmBtn}
        showBtn={showBtn}
        onClose={onClose}
        targetUuid={targetUuid}
        targetType={targetType}
        targetName={targetName}
        targetSubUuid={targetSubUuid}
        targetArea={targetArea}
        label={label ? label[0] : ''}
        callHandleUpdateRenewalType={callHandleUpdateRenewalType}
        disabled={disabled}
      />
      {showMessage === true &&
        (data || notes ? (
          <NoteList notes={notes ? notes : getPaginatedNodes(data)} />
        ) : (
          <Alert icon={<Warning />} color="error" className="alert-container">
            <AlertTitle sx={{ margin: 0 }}>
              The Converge API is not returning notes
            </AlertTitle>
          </Alert>
        ))}
    </Grid>
  );
};
